import { useNavigate } from "react-router";
import { Badge, Card } from "react-bootstrap";
import {
    PeopleFill,
    Calendar3
} from "react-bootstrap-icons";

import { STATES } from "../study_overview/StudyOverviewLayout";

import { reformatDate } from "../../components/CommonFunctions";

import "./Dashboard.scss";

export default function StudyBox(props) {

    const navigate = useNavigate()
    const study = props.study

    const handleClickOverview = (event) => {
        event.preventDefault()
        navigate("/study/"+study.id+"/overview")
    }

    function getStatusLabel(study) {
        if (study.state === STATES.SETUP) {
            return <Badge pill className="ms-auto status-pill status-setup">Setup</Badge>
        }
        if (study.state === STATES.RUNNING) {
            const startsInFuture = new Date(study.startDate.split('T')[0]) > new Date()
            if (startsInFuture) {
                return <Badge pill className="ms-auto status-pill status-start-soon">Start soon</Badge>
            }
            return <Badge pill className="ms-auto status-pill status-running">Running</Badge>
        }
        return <Badge pill className="ms-auto status-pill status-closed">Closed</Badge>
    }

    return (
        <Card className={"study-box"} onClick={handleClickOverview}>
            <Card.Body>
                <Card.Title className="d-flex align-items-start">
                    <span className="study-title">{study.name}</span>
                    {getStatusLabel(study)}
                </Card.Title>
                <Card.Text as="div">
                    <span className="study-info">
                        <span className="label"><span className="icon icon-date"><Calendar3 /></span> Date</span>
                        <span className="data"> {reformatDate(study.startDate) + " – " + reformatDate(study.endDate)} </span>
                    </span>
                    <span className="study-info">
                        <span className="label"><span className="icon icon-participants"><PeopleFill/></span> Participants</span>
                        <span className="data"> {study.done_participants} </span>
                        {study.in_progress_participants > 0 && <span className="data" style={{color: 'red'}}> {" (" + (study.done_participants + study.in_progress_participants) + ")"} </span>}
                        <span className="data"> {" / " + study.total_participants} </span>
                    </span>
                </Card.Text>
            </Card.Body>
        </Card>
    )
}